import {Component, ViewChild} from '@angular/core';
import {FileItem, FileLikeObject, FileUploader} from 'ng2-file-upload';
import {ModalDirective} from 'ngx-bootstrap/modal';
import {throwError} from 'rxjs';
import {ConfigService} from '../services/config.service';
import {EventsEmitterService} from '../services/emitter.service';
import {LogService} from '../services/log.service';
import {SecurityService} from '../services/security.service';
import {VisualsService} from '../services/visuals.service';
//If service needed
//import { RecFileUploadService } from './recFileUpload.service';

@Component({
  selector: 'baseUploaderComponent',
  template: '',
})
export class BaseUploaderComponent {
  @ViewChild('errorModal') public errorModal: ModalDirective;
  @ViewChild('fileUpload') fileUpload: any;

  public group = '';
  public visuals: any = {};
  public genericVisuals: any = {};
  //Uploader Constractor vars
  public URL = '';
  public uploader: FileUploader;
  public uploading: boolean = false;
  public allowedMimeType = ['text/plain'];
  public maxFileSize = 10 * 1024 * 1024; //10MB
  public queueLimit = 1;

  //File drop/select message
  public quequeMsg: string = '';

  //Response message
  public resultType: boolean = true;
  public resultMsg: string = '';
  public resultDetails: any = [];

  public intRegex = /(^0$)|(^[1-9]\d*$)/;

  constructor(
    public securityService: SecurityService,
    public configService: ConfigService,
    public logger: LogService,
    public visualsService: VisualsService,
    public eventsEmitterService: EventsEmitterService,
  ) {
    this.initLoader();
  }

  ngOnInit() {
    this.uploader.onBeforeUploadItem = (item) => {
      item.withCredentials = false;
    };
    this.uploader.onAfterAddingFile = (item) => {
      this.quequeMsg = '';
    };

    this.uploader.onWhenAddingFileFailed = (item, filter, options) =>
      this.onWhenAddingFileFailed(item, filter, options);
  }

  public onWhenAddingFileFailed(item: FileLikeObject, filter: any, options: any) {
    this.quequeMsg = '';
    this.logger.log(filter.name);
    switch (filter.name) {
      case 'fileSize':
        this.quequeMsg = this.visuals.fileSize + this.maxFileSize / 1024 / 1024 + '(MB)';
        break;
      case 'mimeType':
        this.quequeMsg = this.visuals.mimeType + this.allowedMimeType.join();
        break;
      case 'queueLimit':
        this.quequeMsg = this.visuals.queueLimit; //+ " ( Max " + this.queueLimit + " )";
        this.fileUpload.nativeElement.value = '';
        this.uploader.clearQueue();
        break;
      default:
        this.logger.log('Unknown error, filter = ' + filter.name);
        this.quequeMsg = this.visuals.uploadGenericError;
    }
  }

  public removeCustom(item: FileItem) {
    //trick to be able to remove and add the same item
    this.fileUpload.nativeElement.value = '';
    item.remove();
    this.uploader.clearQueue();
  }

  public uploadCustom(item: FileItem) {
    this.uploading = true;
    this.securityService.checkToken().subscribe({
      next: (data) => {
        this.uploader.authToken = 'Bearer ' + this.securityService.getFromStorage('access_token');
        item.upload();

        this.uploader.onCompleteItem = (item: any, response: any, status: any, headers: any) => {
          if (response == 'OK') {
            this.resultType = true;
            this.resultMsg = this.visuals.dataSuccess || 'Success';
            this.uploading = false;
          } else {
            this.resultType = false;
            this.resultMsg = this.visuals.dataError || 'Error';
            this.logger.log(response);
            if (response) {
              if (
                /<(?=.*? .*?\/ ?>|br|hr|input|!--|wbr)[a-z]+.*?>|<([a-z]+).*?<\/\1>/i.test(response)
              ) {
                this.resultDetails = [this.visuals.uploadGenericError];
              } else {
                try {
                  let jsonResponse = JSON.parse(response);
                  this.resultDetails = jsonResponse['errorList'];
                } catch (e) {
                  this.resultDetails = [response];
                }
              }
            } else {
              this.resultDetails = [this.visuals.uploadGenericError];
            }
            this.uploading = false;
          }
        };
      },
      error: (error) => {
        this.uploading = false;
        return throwError(() => new Error(error));
      },
    });
  }

  public getVisuals() {
    this.genericVisuals = this.visualsService.getFromStorageAsJSON('visualsArray')['generic'];
    this.visuals = this.visualsService.getFromStorageAsJSON('visualsArray')[this.group];
  }

  public initLoader(): void {
    //abstract implmented by subclasses
  }

  public hasBaseDropZoneOver: boolean = false;
  public hasAnotherDropZoneOver: boolean = false;

  public fileOverBase(e: any): void {
    this.hasBaseDropZoneOver = e;
  }

  public fileOverAnother(e: any): void {
    this.hasAnotherDropZoneOver = e;
  }

  public showChildModal(): void {
    this.errorModal.show();
  }

  public hideChildModal(): void {
    this.errorModal.hide();
  }
}
